import { getArticleByKey } from './article';
import ActionTypes from '../constants/ActionTypes';
import { getLatestArticles } from '../selectors/latest-articles';
import { LETTER_COUNTS_KEY, FEATURED_TOPICS_KEY } from '../actions/topic';

export function isTopicLoaded(state, key, page) {
  const pagedKey = page && !Number.isNaN(page) ? `${key}-${page}` : key;
  return (
    state.topics.status[pagedKey] &&
    state.topics.status[pagedKey] === ActionTypes.FETCH_TOPIC_SUCCESS
  );
}

export function getTopicLetterCounts(state) {
  return state.topics.list[LETTER_COUNTS_KEY] && state.topics.list[LETTER_COUNTS_KEY].topics;
}

export function getFeaturedTopics(state) {
  return state.topics.list[FEATURED_TOPICS_KEY] && state.topics.list[FEATURED_TOPICS_KEY].topics;
}

export function getTopicsByLetter(state, letter) {
  const key = `__LETTER__${letter}`.toUpperCase();
  return state.topics.list[key] && state.topics.list[key].topics;
}

export function getTopicByArticleKey(state, key) {
  const { topicKey } = getArticleByKey(state, key);
  return getTopicByKey(state, topicKey);
}

export function getTopicByKey(state, key, page) {
  const pagedKey = page && !Number.isNaN(page) ? `${key}-${page}` : key;
  return state.topics.list[pagedKey] ? { ...state.topics.list[pagedKey], key } : {};
}

export function getSecondaryTopicsByArticleKey(state, key) {
  const { secondaryTopics } = getArticleByKey(state, key);

  if (!secondaryTopics) {
    return [];
  }

  return secondaryTopics.map(key => getTopicByKey(state, key));
}

export function getLatestTopicArticlesByArticleKey(state, key) {
  const { articles } = getTopicByArticleKey(state, key);

  if (!articles) {
    // Fall back to generic latest articles
    const latestArticles = getLatestArticles(state);
    return latestArticles.filter(article => article.key !== key);
  }

  return articles.filter(article => article.key !== key);
}
